<template>
  <Dialog v-model:open="isOpen">
    <slot />

    <DialogContent class="h-[90vh] max-w-4xl p-0">
      <div class="flex h-full">
        <!-- Sidebar Navigation -->
        <div class="w-64 border-r bg-muted/30 p-4">
          <DialogHeader class="mb-6 text-left">
            <DialogTitle>{{ t("settings.title") }}</DialogTitle>
          </DialogHeader>

          <nav class="space-y-2">
            <Button
              v-for="page in settingsPages"
              :key="page.key"
              :variant="currentPage === page.key ? 'default' : 'ghost'"
              class="w-full justify-start"
              role="tab"
              @click="currentPage = page.key"
            >
              <component :is="page.icon" class="mr-2 h-4 w-4" />
              {{ t(page.label) }}
            </Button>
          </nav>
        </div>

        <div class="flex flex-1 flex-col">
          <div class="flex-1 overflow-y-auto p-6">
            <div v-if="currentPage === 'general'">
              <SettingsGeneral />
            </div>

            <div v-else-if="currentPage === 'organizations'">
              <SettingsOrganizations />
            </div>

            <div v-else-if="currentPage === 'members'">
              <SettingsMembers />
            </div>

            <div v-else-if="currentPage === 'mcpServers'">
              <SettingsMcpServers />
            </div>
          </div>
        </div>
      </div>
    </DialogContent>
  </Dialog>
</template>

<script setup lang="ts">
import { SETTINGS_PAGES } from "~/utils/settings";

const { t } = useI18n();

const isOpen = defineModel<boolean>("open", { default: false });
const currentPage = defineModel<string>("currentPage", { default: "general" });

const settingsPages = SETTINGS_PAGES;

// No automatic reset needed if we use defineModel
</script>
